// @flow

const editStaffDialogStyles = {
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }),
  card: {
    borderRadius: 0,
    width: 200
  },
  dialogFormCtr: (theme) => ({
    height: 'auto',
    display: 'flex',
    flexDirection: 'column'
  }),
  grow: (theme) => ({
    flexGrow: 1,
    overflowY: 'visible'
  }),
  secondInput: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  error: (theme) => ({
    color: theme.palette.error.main
  }),
  userProfileSubMenuCollapse: {
    width: '20%'
  },
  itemTextCtr: {
    cursor: 'pointer'
  }
};

export default editStaffDialogStyles;